import cx from 'classnames'
import { useState } from 'react'

import { Checkbox } from '../../../shared/NarusMaterial'
import { useIGAO } from '../../context'
import {
  cancelledOrCompleted,
  capitalize,
  filterItemsByStatus,
  notEditableItem,
  favorable,
  isFavorable,
  withDivider
} from '../../utils'
import { Issue } from '../issues'
import { Single as SingleSelect } from '../selects'

import styles from './item.module.scss'

export function Single ({
  item,
  handleChecked,
  handleCheckbox,
  handleInputSubmit,
  handleBatch,
  prevItem,
  selectedIssueId,
  setSelectedIssueId
}) {
  const { filters, pageData: { lists } } = useIGAO()
  const [ editId, setEditId ] = useState(null)
  const isChecked = isFavorable(item)
  const favorableAnsw = favorable(item.unfavorable)

  const filteredIssues = filterItemsByStatus(item.issues, filters).sort(
    (prev, next) => notEditableItem(prev) - notEditableItem(next)
  )

  let disableCheck = false

  disableCheck = item.issues?.some(i => !cancelledOrCompleted(i))

  const handleOnClick = () => {
    if (!disableCheck) {
      handleCheckbox(item.id, favorableAnsw)
    }
  }

  return (
    <>
      {withDivider(prevItem, filters)}
      <div
        id={item.id}
        className={cx(styles.itemWrap, {
          [styles.filled]: filteredIssues.length > 0
        })}
      >
        <div className={styles.item}>
          <div className={styles.innerBody}>
            <div className={styles.itemLabel}>
              <button
                className={cx({
                  [styles.active]: !disableCheck
                })}
                data-cy='favorable-btn'
                onClick={handleOnClick}
              >
                {item?.label}
              </button>
            </div>
            <div className={styles.selects}>
              {item.relations.map(rel => (
                <SingleSelect
                  relation={rel}
                  handler={handleChecked}
                  disabled={isChecked}
                  issues={item.issues}
                  key={rel.id}
                  lists={lists}
                  itemId={item.id}
                />
              ))}
            </div>
          </div>
          <div
            style={{
              width: '60px',
              padding: '8px',
              borderRadius: '10px'
            }}
            className={cx({ [styles.diff]: Object.prototype.hasOwnProperty.call(item?.diff ?? {}, 'answer') })}
          >
            <Checkbox
              label={capitalize(favorableAnsw)}
              onChange={() => {
                if (!disableCheck) {
                  handleCheckbox(item.id, favorableAnsw)
                }
              }}
              value={isChecked}
              labelClassName={styles.igaoLabel}
              disabled={disableCheck}
            />
          </div>
        </div>
      </div>
      {filteredIssues?.length > 0 && (
        <div
          className={styles.issueList}
          data-cy='issue-list'
        >
          {filteredIssues?.map(issue => (
            <Issue
              key={issue.id}
              item={item}
              issue={issue}
              selected={selectedIssueId === issue.id}
              setSelectedIssueId={setSelectedIssueId}
              editId={editId}
              setEditId={setEditId}
              handleBatch={handleBatch}
              handleInputSubmit={handleInputSubmit}
            />
          ))}
        </div>
      )}
    </>
  )
}
